export default "__VITE_ASSET__DEgWLmqZ__"